import React from 'react';

// MUI Theme
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SettingsState } from '../../../../redux/slices/settingsSlice';
import FormInputCollection from '../../../common/FormInputCollection/FormInputCollection';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '5px',
  },
  toggleButtonGroup: {
    height: '36px',
    marginLeft: '4px',
    backgroundColor: 'white',
  },
  toggleButton: {
    '&.MuiToggleButton-root': {
      fontSize: 'x-small',
      whiteSpace: 'nowrap',
    },
  },
}));

interface TasksQueueStatusTabsProps {
  taskStatusToggles: number[];
  settingStates: SettingsState;
  handleTaskStatusToggle: (event: React.MouseEvent<HTMLElement>, newValues: number[]) => void;
}

const TasksQueueStatusTabs: React.FC<TasksQueueStatusTabsProps> = React.memo(({ taskStatusToggles, settingStates, handleTaskStatusToggle }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <FormInputCollection label='Status'>
        <ToggleButtonGroup value={taskStatusToggles} onChange={handleTaskStatusToggle} aria-label='Task Status' className={classes.toggleButtonGroup}>
          {settingStates.taskStatus?.value.map((task) => {
            return (
              <ToggleButton key={task.text} value={task.text} aria-label={task.value} className={classes.toggleButton}>
                {task.value}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </FormInputCollection>
    </div>
  );
});

export default TasksQueueStatusTabs;
